import { render, staticRenderFns } from "./Reciever.vue?vue&type=template&id=c2d8af56&scoped=true"
import script from "./Reciever.vue?vue&type=script&lang=js"
export * from "./Reciever.vue?vue&type=script&lang=js"
import style0 from "./Reciever.vue?vue&type=style&index=0&id=c2d8af56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d8af56",
  null
  
)

export default component.exports